export default function CircularRectangel({className}){
    return(
        <div className={`${className} h-[40px] rounded-full`}/>
    );
}